<template>
  <div class="error-page">
    <div class="error-content">
      <h1 class="error-code">{{ error?.statusCode || '404' }}</h1>
      <h2 class="error-title">页面未找到</h2>
      <p class="error-desc">抱歉，您访问的页面不存在或已被移除</p>
      <ElButton type="primary" size="large" @click="handleError">
        返回首页
      </ElButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'
import { clearError } from '#imports'

// 定义 props 接收 error 对象
const props = defineProps({
  error: Object as () => NuxtError
})

// 使用 clearError 清除错误并跳转
const handleError = () => {
  clearError({ redirect: '/' })
}
</script>

<style scoped>
.error-page {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background-color: #fff;
}

.error-content {
  text-align: center;
}

.error-code {
  font-size: 120px;
  font-weight: bold;
  color: #333;
  line-height: 1;
  margin-bottom: 20px;
  font-family: Arial, sans-serif;
}

.error-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 16px;
  font-weight: 500;
}

.error-desc {
  font-size: 16px;
  color: #666;
  margin-bottom: 32px;
}
</style>
